import { ESidebarView } from "@frontend-shared/types";

// NOTE: `as const` so the keys stay literal — i18next types `t` against the key
// union, and a widened `string` would not be assignable.
export const SIDEBAR_VIEW_LABEL_KEYS = {
  [ESidebarView.CHATS]: "view_switch.chats",
  [ESidebarView.ASSISTANT_CHATS]: "view_switch.assistant_chats",
  [ESidebarView.FOLDERS]: "view_switch.folders",
} as const;

// NOTE: NSAI-6342 — the tour used to point at the chat-history heading and at
// the folders section; the tabs replaced both, so each step now points at the
// tab that opens what it describes. This is what mobile did with the same two
// ids (NSAI-5622). They must survive verbatim: a step whose target is missing
// highlights nothing and fails silently.
export const SIDEBAR_VIEW_TOUR_IDS: Partial<Record<ESidebarView, string>> = {
  [ESidebarView.CHATS]: "sidebar-chat-history",
  [ESidebarView.FOLDERS]: "sidebar-chat-folders",
};

// NOTE: NSAI-6342 — how long a dragged chat has to be held over a tab before
// that tab opens.
export const SPRING_LOAD_DELAY_MS = 500;
